import React from 'react'

import styles from './fill.module.scss'

const FillBlock = ({ block }) => !block.disabled ? (
  <span className={styles.span} />
) : null

export { FillBlock }
